export default {"src":"/_next/static/media/fast.8570c95c.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};